/** @jsxImportSource @emotion/react */
import React from 'react';
import { css } from '@emotion/react';
import { colors, fontSizes } from 'src/constants/variables';

type Props = {
    title: string;
    price: string | number;
    isBold?: boolean;
};

export const OfferPreviewDetailsElement: React.FC<Props> = ({ title, price, isBold }) => (
    <div css={[offerPreviewDetailsElementStyles.namePriceContainer, isBold && css`font-family: 'Gebauer-Medium', sans-serif;`]}>
        <div css={offerPreviewDetailsElementStyles.nameLabel}>{title}</div>
        <div css={offerPreviewDetailsElementStyles.price}>{price}</div>
    </div>
);

export const offerPreviewDetailsElementStyles = {
    price: css`
        color: ${colors.fontHeader};
        font-family: 'Gebauer-Medium', sans-serif;
    `,
    nameLabel: css`
        text-align: right;
        width: 93%;
    `,
    namePriceContainer: css`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;

        font-size: ${fontSizes.mSmall};
        line-height: 28px;
        letter-spacing: 0;
        font-family: 'Gebauer-Regular', sans-serif;
    `,
};
